import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { title } from '../../routes/path';
import { currentCompany } from '../../../actionTypes';
import { formatPageTitle } from '../../../utils/textFormaters';
import { useCompanyInfo } from '../../../utils/effects/useCompanyInfo';
import FormBuilder from '../../containers/FormBuilder';
import { enumTypes } from '../../../utils/constants/formBuilder';

const workingHoursQuestionTypes = [enumTypes.Dropdown, enumTypes.YesNo];

const OwnerWorkingHoursQuestions = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { companyId, companyName } = useCompanyInfo(id);

  const { loading, saving, success, error, list } = useSelector(
    store => store.currentCompany.ownerWorkingHoursQuestions,
  );

  useEffect(() => {
    dispatch({
      type: currentCompany.ownerWorkingHoursQuestions.get.start,
      payload: { companyId },
    });
  }, [companyId, dispatch]);

  const handleSave = values =>
    dispatch({
      type: currentCompany.ownerWorkingHoursQuestions.create.start,
      payload: { companyId, values },
    });

  return (
    <>
      <Helmet>
        <title>
          {formatPageTitle(title.private.company.ownerWorkingHoursQuestions, {
            companyName,
          })}
        </title>
      </Helmet>
      <FormBuilder
        loading={loading}
        saving={saving}
        success={success}
        error={error}
        list={list}
        handleSave={handleSave}
        companyId={companyId}
        pageTitle="Working Hours Questions"
        questionTypes={workingHoursQuestionTypes}
        withConditionalQuestions={false}
      />
    </>
  );
};

export default OwnerWorkingHoursQuestions;
